export default class ToggleElement {

  constructor(triggerBtnSelector, targetElementSelector, openClass, activeBtnClass) {
    this.triggerBtns = document.querySelectorAll(triggerBtnSelector);
    this.targetElementSelector = targetElementSelector;
    this.targetElements = document.querySelectorAll(targetElementSelector);
    this.activeBtnClass = activeBtnClass;
    this.openClass = openClass;
    this.bindToggleOnBtnClick();
    this.bindCloseOnDocumentClick();
  }

  //Toggle element on trigger button click
  bindToggleOnBtnClick() {

    this.triggerBtns.forEach((triggerBtn) => {

      triggerBtn.addEventListener('click', (event) => {

        this.targetElements.forEach((targetElement) => {
          const targetElementParent = targetElement.parentElement;

          if (targetElement.classList.contains(this.openClass)) {
            event.target.classList.remove(this.activeBtnClass);
          } else {
            event.target.classList.add(this.activeBtnClass);
          }

          if (targetElementParent.contains(event.target)) {

            if (event.target.nodeName === 'INPUT') {
              const thisSiblingInput = event.target.parentElement.querySelector(this.targetElementSelector),
                thisSiblingInputValue = thisSiblingInput.value,
                thisSiblingInputClassList = thisSiblingInput.classList;

              if (thisSiblingInputValue === '' || (thisSiblingInputValue !== '' && !thisSiblingInputClassList.contains(this.openClass))) {
                event.preventDefault();
                thisSiblingInputClassList.toggle(this.openClass);
                thisSiblingInput.focus();
              }
            }else {
              event.preventDefault();
              targetElement.classList.toggle(this.openClass);
            }
          }
        });
      });
    });
  }

  //Close element on Document click
  bindCloseOnDocumentClick() {

    document.addEventListener('click', (event) => {
      const eventTarget = event.target,
        triggerBtnsArray = Array.from(this.triggerBtns),
        targetElementArray = Array.from(this.targetElements);

      if ((!eventTarget.closest(this.targetElementSelector) && !triggerBtnsArray.includes(eventTarget) && !targetElementArray.includes(eventTarget)) && document.querySelector(`.${this.openClass}`)) {
        document.querySelector(`.${this.openClass}`).classList.remove(this.openClass);
      }
    });
  }
}
